import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { FeatureNames } from './shared/models/feature-names.enum';
import { PricesService } from './shared/services/prices/prices.service';
import { FeaturesStatusService } from './shared/services/util/features-status.service';
import { TranslatableParametersService } from './shared/services/util/translatable.parameters.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    public title: string = 'kairos';

    constructor(
        private readonly translate: TranslateService,
        private readonly router: Router,
        private readonly featuresStatusService: FeaturesStatusService,
        private readonly priceService: PricesService,
        private readonly translatableService: TranslatableParametersService,
        private titleService: Title
    ) {
        this.translate.addLangs(['en', 'fr', 'pt-br']);
        this.translate.setDefaultLang('pt-br');

        const browserLang = this.translate.getBrowserLang();
        translate.use(browserLang.match(/en|fr|pt-br/) ? browserLang : 'pt-br');
    }

    public getAllFeatureStatus(): void {
        // Get all Features names
        const featuresList: Array<[string, FeatureNames]> = Object.entries(FeatureNames);

        // Load all feature statuses when loading the app
        featuresList.map(([key, value]) => this.featuresStatusService.getFeatureStatus(value, true).subscribe());
    }

    public ngOnInit(): void {
        if (environment?.pageTitle){
            this.titleService.setTitle(environment.pageTitle);
        }

        this.getAllFeatureStatus();
        this.priceService.getShippingData(true).subscribe();
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });

        this.translatableService.getTexts().subscribe();
    }
}
